import { faSparkles } from "@fortawesome/pro-regular-svg-icons";
import React from "react";

import { mdService } from "src/base-components/TextEditor/MarkdownService";
import { CaseBlock, CaseBlockProps } from "src/cases/caseView/CaseBlock";
import { CaseBlockMarkdownData } from "src/cases/queries/casesTypes";
import { EmptyState } from "src/design-system/EmptyState";

type MarkdownBlockProps = Omit<CaseBlockProps, "children"> & {
  data: CaseBlockMarkdownData;
};

export const MarkdownBlock: React.FC<MarkdownBlockProps> = ({
  data,
  ...props
}) => {
  if (!data.content) {
    const isEmpty = data.content === "";
    const headline = isEmpty ? `Content is empty` : `Content not generated yet`;
    const description = isEmpty
      ? "There's currently no content to display"
      : `Once generated, it will be displayed here`;

    return (
      <CaseBlock {...props}>
        <EmptyState
          description={description}
          headline={headline}
          icon={faSparkles}
        />
      </CaseBlock>
    );
  }

  return (
    <CaseBlock {...props}>
      <div
        //skipcq: JS-0440
        dangerouslySetInnerHTML={{
          __html: mdService.toHtml(data.content),
        }}
        className="tktl-markdown text-gray-800 font-inter-normal-12px"
      />
    </CaseBlock>
  );
};
